import request from '@/utils/request'

// 登录 - application/json
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      principal: data.principal,
      credentials: data.credentials,
      smscode: data.smscode
    }
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/api/home/logout',
    method: 'get'
  })
}
